export const SET_PROFILE_DETAILS = "profile/SET_PROFILE_DETAILS"